import {
  AmlEntityTypeQuestion,
  ComplianceInstitutionProfileInput,
  InstitutionAccountTypeEnum,
} from "../../graphql/supergraphTypes";
import {
  getProfileDate,
  prepareAddressFromForm,
} from "../common/ProfileManagement/profile_utils";
import { EntityProfileFormValues } from "../EntityForm/types";
import { DeclarationProfileType } from "../profile/ProfileDeclaration/types";

export const provideDefaultQuestionIds = (
  questions: Array<AmlEntityTypeQuestion>,
): Array<number> => {
  return questions
    .filter((q) => q?.isDefault)
    .map((q) => {
      return q?.targetAmlEntityTypeId;
    });
};

const provideNonDefaultQuestions = (
  questions: Array<AmlEntityTypeQuestion>,
): Array<{
  id: string;
  question: string;
  answer: string;
  targetAmlEntityTypeId: number;
}> => {
  return questions
    .filter((q) => !q?.isDefault)
    .map((q) => {
      return {
        id: q?.id.toString(),
        question: q?.text || "",
        description: q?.subText,
        answer: "",
        targetAmlEntityTypeId: q?.targetAmlEntityTypeId,
      };
    });
};

export const provideQuestionsWithAnswers = (
  questionsResponses: Array<AmlEntityTypeQuestion>,
  entityTypeId: number | null,
) => {
  const questions = provideNonDefaultQuestions(questionsResponses);
  if (entityTypeId === null) {
    return questions;
  }
  const questionsWithAnswers = [...questions];

  questionsWithAnswers.forEach((question) => {
    if (question.targetAmlEntityTypeId === entityTypeId) {
      question.answer = "Yes";
    } else {
      question.answer = "No";
    }
  });
  return questionsWithAnswers;
};

export const prepareInstitutionPayload = (
  caseId: number,
  values: EntityProfileFormValues,
  profile?: DeclarationProfileType | null,
  amlEntityId?: number | null,
): ComplianceInstitutionProfileInput => {
  return {
    caseId: caseId,
    legalBusinessName: values.legalBusinessName || "",
    accountType: values.entityType as InstitutionAccountTypeEnum,
    dateOfFormation: getProfileDate(values?.dateOfFormation),
    taxId: values?.identificationNumber,
    taxIdType: profile?.taxIdType,
    amlEntityId: amlEntityId,
    relationshipType: profile?.parentRelationships?.map(
      (relationship) => relationship.relationshipType,
    ),
    addresses: [prepareAddressFromForm(values)],
  };
};
